/**
 * 総合TOP / 都道府県TOP:
 * エリアバーを含むヘッダーの高さを、追従ナビの位置に反映する。
 */
const homeHeaderSticky = () => {
    if (document.body.id !== "page-home") return;

    const header = document.querySelector(".l-header");
    if (!header) return;

    const updateHeight = () => {
        document.body.style.setProperty("--l-header-h", `${header.offsetHeight}px`);
    };

    updateHeight();
    const observer = new ResizeObserver(updateHeight);
    observer.observe(header);
};

export default homeHeaderSticky;
